module.exports = {"370828001":"金乡街道","370828002":"高河街道","370828003":"鱼山街道","370828004":"王丕街道","370828101":"羊山镇","370828102":"胡集镇","370828103":"霄云镇","370828104":"鸡黍镇","370828107":"司马镇","370828109":"马庙镇","370828110":"化雨镇","370828111":"卜集镇","370828112":"兴隆镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370828.json
// module id = 1547
// module chunks = 0